/*
  Ячейка «Источник» строки начислений: чья строка и что о ней говорит 1С (23.10.2026).

  Решение владельца 23.10.2026: строка, которой коснулся человек (внёс, поправил или внёс
  по ней оплату), принадлежит ручному вводу - ночной обмен её не перезаписывает. Если 1С
  прислала по ней другие суммы, здесь написано, что именно: «В 1С: начислено …, оплачено
  …». Это сверка, а не действие: в расчёт идут цифры строки.
*/

import { date, money } from '../../api/format.js'
import { Tag } from '../Common.jsx'

function sourceOf(row) {
  if (row.entered_by_hand) return { kind: 'calm', title: 'внесено вручную' }
  if (row.paid_by_hand) return { kind: 'calm', title: 'оплата внесена вручную' }
  return { kind: 'muted', title: 'из учётной системы' }
}

function onecText(row) {
  const parts = [`начислено ${money(row.onec.amount)}`, `оплачено ${money(row.onec.paid_amount)}`]
  if (row.onec.due_date !== row.due_date) parts.push(`срок ${date(row.onec.due_date)}`)
  return `В 1С: ${parts.join(', ')}`
}

export default function ChargeSource({ row }) {
  const source = sourceOf(row)
  return (
    <>
      <Tag kind={source.kind}>{source.title}</Tag>
      {row.differs_from_onec && row.onec ? (
        <div className="muted">
          <Tag kind="warn">расхождение с 1С</Tag> {onecText(row)}
        </div>
      ) : null}
    </>
  )
}
